import React from 'react';
import { connect } from 'react-redux';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import { postData } from '../../functions/postData';

import CircularProgress from '@material-ui/core/CircularProgress';
import { arraysHaveSameValues, objectIsNotEmpty } from '../../functions/utils';
import { _ } from '../../functions/translator';

import { GridStack } from 'gridstack';
import 'gridstack/dist/gridstack.min.css';

import ReactDOM from 'react-dom';

class metricModule extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            metricsHTML: null,
            fullscreen: false,
            waitTimeToReload: 1000,
            reloadInProcess: false,
        };
    }

    componentDidMount() {
        this.gridContainer = document.querySelector(`.grid-stack-${this.props.metricKey}`);
        if (this.gridContainer && !this.gridContainer.classList.contains('gridstack-initialized')) {
            this.grid = GridStack.init({ float: true, cellHeight: 1, id: this.props.metricKey}, this.gridContainer );
            this.gridContainer.classList.add('gridstack-initialized');
        }
        this.loadMetric();
    }

    // initializeGrid = () => {
    //     if (!this.grid) {
    //         this.grid = GridStack.init({ float: true, id: this.props.metricKey, column: 40 });
    //     }
    // };

    componentDidUpdate(prevProps) {
        if (!arraysHaveSameValues(prevProps.visibleCardsGroupIds, this.props.visibleCardsGroupIds)
            || (prevProps.metrics !== this.props.metrics && this.props.metrics)) {
            if (!this.state.reloadInProcess) {
                this.setState({ reloadInProcess: true });
                setTimeout(this.loadMetric, this.state.waitTimeToReload);
            }
        }
    }

    updateGrid() {
        if (!this.grid || !this.state.metricsHTML) return;

        if (this.grid.el.querySelector(`[data-metric="${this.props.metricKey}"]`)) return;

        const el = document.createElement('div');
        el.classList.add('grid-stack-item');
        el.setAttribute('gs-w', '12');
        el.setAttribute('gs-h', '200');

        el.setAttribute('data-metric', this.props.metricKey);

        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('grid-stack-item-content');
        el.appendChild(contentWrapper);

        this.grid.el.appendChild(el);
        this.grid.makeWidget(el);
        ReactDOM.render(
                <iframe 
                    title="metric-iframe"
                    ref={ref => this.iframe = ref}
                    srcDoc={this.state.metricsHTML} 
                    width="100%"
                    height='100%'
                    frameborder="0"
                    onLoad={this.resizeIframe}>
                </iframe>
            ,
            contentWrapper
        );
    }


    loadMetric = async () => {
        this.setState({ reloadInProcess: false });
        if (this.state.metricsHTML) {
            this.setState({ metricsHTML: null });
        };
        const data = {
            project_id: this.props.projectId,
            chart_function_name: this.props.metricKey,
            layout_config: this.props.layoutConfig,
            break_user_names: true,
            extra_filters: {
                id: this.props.visibleCardsGroupIds,
            }
        };
        const response = await postData('/web-api/plotly-chart', data);
        this.setState({ metricsHTML: response }, this.updateGrid);

    }

    // renderMetricInGrid = () => {
    //     const gridEl = this.grid.el;
    //     gridEl.innerHTML = '';

    //     const el = document.createElement('div');
    //     el.classList.add('grid-stack-item');
    //     el.setAttribute('gs-w', '12');
    //     el.setAttribute('gs-h', '4');

    //     const contentWrapper = document.createElement('div');
    //     contentWrapper.classList.add('grid-stack-item-content');
    //     el.appendChild(contentWrapper);

    //     this.grid.el.appendChild(el);
    //     this.grid.makeWidget(el);

    //     ReactDOM.render(
    //         <div className='iframe-container'>
    //             <iframe 
    //                 title="metric-iframe"
    //                 ref={ref => this.iframe = ref}
    //                 srcdoc={this.state.metricsHTML} 
    //                 frameborder="0" 
    //                 width="100%" 
    //                 onLoad={this.resizeIframe}>
    //             </iframe>
    //         </div>,
    //         contentWrapper
    //     );
    // };

    resizeIframe = (event=null) => {
        const iframeObj = event ? event.target : this.iframe;
        if (!iframeObj) return;
        iframeObj.contentWindow.document.body.style.margin = '0px';
        iframeObj.contentWindow.document.body.style.overflowY = 'hidden';
        let iframeTotalHeight =  iframeObj.contentWindow.document.body.scrollHeight;
        //iframeObj.style.height = `${iframeTotalHeight}px`;
        iframeObj.style.width = '100%';
        this.removePlotlyIcon(iframeObj.contentWindow.document);
        setTimeout(() => {
            iframeObj.contentWindow.document.body.style.overflowY = 'auto';
        }, 1000);
    }
    
    removePlotlyIcon = (iframeDocument) => {
        const plotlyIconElements = iframeDocument.getElementsByClassName('modebar-btn plotlyjsicon modebar-btn--logo');
        if (plotlyIconElements.length) {
            plotlyIconElements[0].remove();
        }
    }

    handleFullScreen = () => {
        this.setState({ fullscreen: !this.state.fullscreen });
        this.resizeIframe();
    }

    handleClose = () => {
        this.props.closeCallback(this.props.metricKey);
    }

    render() {
        const isMetricEmpty = this.state.metricsHTML && !objectIsNotEmpty(this.state.metricsHTML);
        const fullScreenIcon = this.state.fullscreen ? <FullscreenExitIcon/> : <ZoomOutMapIcon/>;
        const fullScreenClass = this.state.fullscreen ? 'metrics-module full-metrics-module' : 'metrics-module';
        const zIndex = this.state.fullscreen ? 1000 : 1;
        const gridStackDisplay = !isMetricEmpty && this.state.metricsHTML
        return(
            <Slide in={true} direction='left' style={{zIndex: zIndex}}>
                <div className={fullScreenClass}>
                    <p className='mt-0 mb-3'>
                        {this.props.description}
                        <span className="close-button" onClick={this.handleClose}><CloseIcon/></span>
                        <span className="close-button mr-2" onClick={this.handleFullScreen}>{fullScreenIcon}</span>
                    </p>
                    <div className={`grid-stack grid-stack-${this.props.metricKey}`} style={{height:'100% !important', display: gridStackDisplay ? 'block' : 'none'}}></div>
                    { isMetricEmpty ? 
                        <div className='not-available-metric-container'>
                            <p>{_('Métrica No Disponible')}</p>
                        </div>
                        :
                        this.state.metricsHTML ? 
                            <div >
                                
                            </div>
                            : 
                            <div className="circular-progress-center">
                                <CircularProgress/>
                            </div>
                    }
                </div>
            </Slide>
        );
    } 
}

function mapStateToProps( state ){
    return {
        metrics              : state.switches.metrics,
        visibleCardsGroupIds : state.visibleCardsGroupIds,
        projectId            : state.projectData.id,
    }
}

export default connect(mapStateToProps)(metricModule);